<template>
  <!-- eslint-disable vue/no-mutating-props -- account is a nested reactive object from parent form state, bound via v-model -->
  <fieldset>
    <div class="group">
      <div class="field">
        <label :for="fieldId('account', index, 'backup-relation')">{{ $t('relation') }}</label>
        <div>
          <select :id="fieldId('account', index, 'backup-relation')" v-model="account.backup.relation.option">
            <option v-for="option in backupRelations" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
          <v-form-error :error="errors[`accounts.${index}.backup.relation.option`]" />
        </div>
      </div>

      <div v-if="account.backup.relation.option === 'other'" class="field">
        <label :for="fieldId('account', index, 'backup-relation-other')">{{ $t('relation') }}</label>
        <div>
          <input
            :id="fieldId('account', index, 'backup-relation-other')"
            type="text"
            v-model="account.backup.relation.other"
          />
          <v-form-error :error="errors[`accounts.${index}.backup.relation.other`]" />
        </div>
      </div>
      <div v-else class="field"></div>
    </div>
  </fieldset>

  <fieldset v-if="showDuplicateToggle">
    <label class="checkbox">
      <input type="checkbox" value="1" v-on:change="onDuplicateToggle" />
      <span class="label">{{ $t('same as above') }}</span>
    </label>
  </fieldset>

  <fieldset class="address">
    <div v-if="showName" class="field">
      <label :for="fieldId('account', index, 'backup-name')">{{ $t('name') }}</label>
      <div>
        <input :id="fieldId('account', index, 'backup-name')" type="text" required v-model="account.backup.name" />
        <v-form-error :error="errors[`accounts.${index}.backup.name`]" />
      </div>
    </div>

    <AddressFields
      :address="account.backup.address"
      :errors="errors"
      :error-prefix="`accounts.${index}.backup.address`"
      :countries="countries"
    />
  </fieldset>

  <fieldset>
    <div class="group">
      <div class="field">
        <label :for="fieldId('account', index, 'backup-email')">{{ $t('email') }}</label>
        <div>
          <input
            :id="fieldId('account', index, 'backup-email')"
            type="email"
            name="email"
            required
            v-model="account.backup.email"
          />
          <v-form-error :error="errors[`accounts.${index}.backup.email`]" />
        </div>
      </div>

      <div class="field">
        <label :for="fieldId('account', index, 'backup-phone')">{{ $t('cellphone') }}</label>
        <div>
          <vue-tel-input
            v-model="account.backup.phone"
            :input-options="{ id: fieldId('account', index, 'backup-phone'), placeholder: '' }"
            autocomplete="tel"
            default-country="nl"
          ></vue-tel-input>
          <v-form-error :error="errors[`accounts.${index}.backup.phone`]" />
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import { useRegistrationContext } from '/@front:shared/composables/useRegistrationContext'
import type { Account } from '/@front:shared/registration'
import { fieldId } from '/@front:shared/utils'

import AddressFields from './AddressFields.vue'

const props = withDefaults(
  defineProps<{
    account: Account
    index: number
    errors: Record<string, string>
    showName?: boolean
    showDuplicateToggle?: boolean
  }>(),
  {
    showName: false,
    showDuplicateToggle: false,
  },
)

const emit = defineEmits<{
  (e: 'copy-address-to-backup', index: number): void
}>()

const { countries, backupRelations } = useRegistrationContext()

const onDuplicateToggle = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.checked) {
    emit('copy-address-to-backup', props.index)
  }
}
</script>
